export default __webpack_public_path__ + "static/media/primal_spirit_texture.289ed597.jpg";